module.exports = __webpack_public_path__ + "assets/img/bgg.b90dec24.png";